import { useState, useMemo } from 'react'
import { Table2 } from 'components/index'
import { Container } from './style'

export interface DistribuicaoItem {
  name: string
  meter: number
  available: number
  sold: number
  price: number
  status: string
}

interface Props {
  data: DistribuicaoItem[]
}

export default function DistribuicaoTable({ data = [] }: Props) {
  const [page, setPage] = useState<number>(1)

  const itemsPerPage = 10

  function tableRows(arr: DistribuicaoItem[]) {
    if (!arr) return []

    return arr.map((item, i) => [
      <div className="grid-item" key={`unidade-${i}`}>
        {item.name}
      </div>,

      <div className="grid-item" key={`meter-${i}`}>
        {item.meter} m²
      </div>,

      <div className="grid-item" key={`sold-${i}`}>
        {item.sold}
      </div>,

      <div className="grid-item" key={`available-${i}`}>
        {item.available}
      </div>,

      <div className="grid-item" key={`price-${i}`}>
        {item.price.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })}
      </div>,

      <div className="grid-item" key={`status-${i}`}>
        <span
          className={`status-badge ${
            item.status === 'Disponível' ? 'green' : 'red'
          }`}
        >
          {item.status}
        </span>
      </div>,
    ])
  }

  const paginatedData = useMemo(() => {
    const start = (page - 1) * itemsPerPage
    return data.slice(start, start + itemsPerPage)
  }, [data, page])

  const columnsWidths = [120, 160, 160, 180, 180, 140]
  const columnGap = 18

  return (
    <Container className="maicccn">
      <Table2
        pageData={tableRows(paginatedData)}
        filterData={data}
        page={page}
        setPage={setPage}
        header={[
          'UNIDADE',
          'M² DA UNIDADE',
          'COTAS VENDIDAS',
          'COTAS DISPONÍVEIS',
          'PREÇO DA UNIDADE',
          'STATUS',
        ]}
        columnsWidths={columnsWidths}
        columnGap={columnGap}
      />
    </Container>
  )
}
